<form [formGroup]="form" (ngSubmit)="submit()">
    <div class="modal-header">
        <h2>
            <svg width="38px" height="37px" viewBox="0 0 38 38">
                <g id="Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"
                    stroke-linejoin="round">
                    <g stroke-width="1.5">
                        <path class="svg-stroke"
                            d="M18,18 C20.7417273,18 22.9090909,15.9962727 22.9090909,13.0909091 L22.9090909,10.6363636 C22.9090909,7.731 20.7417273,5.72727273 18,5.72727273 C15.2582727,5.72727273 13.0909091,7.731 13.0909091,10.6363636 L13.0909091,13.0909091 C13.0909091,15.9962727 15.2582727,18 18,18 Z"
                            id="Stroke-1"></path>
                        <path class="svg-stroke" class="svg-stroke"
                            d="M27.8181818,30.2727273 L27.8181818,26.1818182 C27.8181818,22.5155455 21.3021818,20.4545455 18,20.4545455 C14.6978182,20.4545455 8.18181818,22.5155455 8.18181818,26.1818182 L8.18181818,30.2727273"
                            id="Stroke-3"></path>
                        <path class="svg-stroke"
                            d="M36,18 C36,27.9409091 27.9409091,36 18,36 C8.05909091,36 0,27.9409091 0,18 C0,8.05909091 8.05909091,0 18,0 C27.9409091,0 36,8.05909091 36,18 Z"
                            id="Stroke-5"></path>
                    </g>
                </g>
            </svg>

            <ng-container i18n="@@product.add_category">Add Category</ng-container>
        </h2>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
            <svg version="1.1" x="0px" y="0px" width="14" height="14" viewBox="0 0 14 14">
                <path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square"
                    d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label>Name (EN)</label>
            <input class="form-control" formControlName="name">
        </div>

        <div class="form-group">
            <label>Name (AR)</label>
            <input class="form-control" formControlName="name_ar">
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" class="tu-btn pink" i18n="@@clients.save">Save</button>
    </div>
</form>